// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"694":"component---src-core-share-share-block-template-tsx","989":"component---src-core-pages-page-template-tsx"}[chunkId] || chunkId) + "-" + {"530":"c514905238fc91b2b83f","694":"471ac38be9025a465e30","989":"d77e5f9c57c87513ffe0"}[chunkId] + ".js";
};